import React, { useEffect } from "react"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { getCountryDetails } from "store/actions/countriesAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"

const CountryDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Country Details | Namq`)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, countryDetails } = useSelector(state => state.Countries)

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      11,
      "country_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getCountryDetails(payload))
    }
    fetchOldDetails()
  }, [])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Country Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(countryDetails).length === 0 ? (
                    <p className="text-center my-2">
                      {t("No country details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{"Id"}</th>
                          <td>{countryDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(English)")}</th>
                          <td>{countryDetails?.name}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(عربي)")} </th>
                          <td>{countryDetails?.nameAr}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Country Code")}</th>
                          <td>{countryDetails.countryCode || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Dial Code")}</th>
                          <td>{countryDetails.dialCode || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Display Order")}</th>
                          <td>{countryDetails.displayOrder || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Currency")}</th>
                          <td>{countryDetails.currency || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Tax Title(English)")}</th>
                          <td>{countryDetails?.taxInfo?.title || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Tax Title(عربي)")}</th>
                          <td>{countryDetails?.taxInfo?.titleAr || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Tax Value")}</th>
                          <td>{countryDetails?.taxInfo?.value || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Tax Registered No")}</th>
                          <td>
                            {countryDetails?.taxInfo?.registeredNo || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {countryDetails?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default CountryDetails
